import { Box, Button, Card, CardContent, CardHeader, FormControl, Grid, Typography } from '@mui/material'
import React from 'react'
import { ArrowLeft, ArrowLeftCircle, Save } from 'react-feather'
import { AllowedAccess } from 'react-permission-role'
import { Form, useLocation, useParams } from 'react-router-dom'

import { useFechInitForm } from './hooks'

import { DateChangeSection } from './Sections/DateChangeSection'
import { ApprovalManagement, GeneralFields, InfoContract, ObservationsContract } from './Common'

import { IsuranceCancellation } from './Sections/IsuranceCancellation'
import { GPSRemoval } from './Sections/GSPRemovalSection/GPSRemoval'
import { ModalModule } from '../Modal'
import { ContractTermination } from './Sections/ContractTermination'
import { UncollectibleAccounts } from './Sections/UncollectibleAccounts'
import { JudicialCollection } from './Sections/JudicialCollection'
import { BadDebts } from './Sections/BadDebts'
import { TerminationCreditLegal } from './Sections/TerminationCreditLegal'


export const LegalFormVehiclesManagement = () => {

  const location = useLocation();
  const paramsURL = useParams();
  const useFetchInit = useFechInitForm({location, paramsURL})

  const {
    globalStates,
    FetchData,
    Forms,
    Helpers,
    defaultData,
    //------------- Actions
    Actions
} = useFetchInit

const { identifySelectedRequestType } = Helpers



const {FormRequestGlobal:{formState, onInputChange}} = Forms

const { handleClickCloseForm, onSubmitFormRequests, onSendLogs } = Actions

const { fetchAllTypeManagements, fetchInfoObservations } = FetchData
const { typeManagements } = fetchAllTypeManagements
const { observations } = fetchInfoObservations

const {formOpeningMode, showFormContract} = globalStates


  return (
    <AllowedAccess permissions={['121_VEHICULOS_GESTIONES']} renderAuthFailed={<p>Error</p>}>
      <div className="content">
        <div className='panel-body'>
          <ModalModule useFetchInit={useFetchInit} />
          <form onSubmit={onSubmitFormRequests}>
            <Card style={{zIndex:'1'}}>
                <CardContent>
                  <Typography sx={{color:'warning.main'}} variant='overline' >
                    * campos obligatorios
                  </Typography>
                  
                  <GeneralFields
                    Forms = {Forms}
                    FetchData = {FetchData} 
                    globalStates = {globalStates}
                    Actions = {Actions}
                  />
                  
                  {showFormContract && (
                    <InfoContract
                      formState={formState}
                    />
                  )}


                  {identifySelectedRequestType(typeManagements, formState.idgestiontipo) === 'CFP' && (
                    <>
                      <DateChangeSection useFetchInit={useFetchInit} />
                    </>
                  )}

                  {identifySelectedRequestType(typeManagements, formState.idgestiontipo) === 'PTS' && (
                    <>
                      <IsuranceCancellation useFetchInit={useFetchInit} />
                    </>
                  )}

                  {identifySelectedRequestType(typeManagements, formState.idgestiontipo) === 'RGPS' && (
                    <>
                      <GPSRemoval useFetchInit={useFetchInit} />
                    </>
                  )}

                  {identifySelectedRequestType(typeManagements, formState.idgestiontipo) === 'FDC' && (
                    <>
                      <ContractTermination useFetchInit={useFetchInit} />
                    </>
                  )}

                  {identifySelectedRequestType(typeManagements, formState.idgestiontipo) === 'ECJ' && (
                    <>
                      <UncollectibleAccounts useFetchInit={useFetchInit} />
                    </>
                  )}

                  {identifySelectedRequestType(typeManagements, formState.idgestiontipo) === 'CJ' && (
                    <>
                      <JudicialCollection useFetchInit={useFetchInit} />
                    </>
                  )}


                  {identifySelectedRequestType(typeManagements, formState.idgestiontipo) === 'ECI' && (
                    <>
                      <BadDebts useFetchInit={useFetchInit} />
                    </>
                  )}

                  {identifySelectedRequestType(typeManagements, formState.idgestiontipo) === 'FCJ' && (
                    <>
                      <TerminationCreditLegal useFetchInit={useFetchInit} />
                    </>
                  )}



                  {(formOpeningMode==='READONLY') && (
                    <>
                      <ApprovalManagement
                        formState={formState}
                        optionsAprobacionCheck={defaultData.optionsAprobacionCheck}
                      />

                    </>
                  )} 

                  {(formState.idgestion>0) && (
                    <ObservationsContract
                      formState={formState}
                      onInputChange={onInputChange}
                      onSendLogs={onSendLogs}
                      observations={observations}
                    />
                  )} 

                  <Box className="text-center" sx={{mt: 2}}>
                    <Button 
                        startIcon={<ArrowLeftCircle/>}
                        variant="contained"
                        type="button" 
                        className='btn-round'
                        color='warning'
                        onClick={handleClickCloseForm} 
                        sx={{ marginRight: 1, marginLeft: 1 }}
                    >
                        Volver
                    </Button>

                    {(formOpeningMode==='EDITABLE') && (
                      <Button
                          endIcon={<Save/>}
                          variant="contained"
                          className='btn-round'
                          color='primary'
                          type='submit'
                          sx={{ marginRight: 1, marginLeft: 1 }}
                      >
                        Enviar Gestion
                      </Button>
                    )} 
                  </Box>
                </CardContent>
            </Card>
          </form>
        </div>
      </div>
    </AllowedAccess>
  )
}
